module.exports = __webpack_public_path__ + "img/zain_landscape.b4cf58c9.jpg";